export default {
  tiles: [
    {
      id: 0,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/csr/images/logo-inclusiv.png',
      imageAlt: 'inclusiv',
      imageWidth: '400',
      imageHeight: '69',
      linkUrl: 'https://www.inclusiv.org/',
    },
    {
      id: 1,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/csr/logo-shfcu-v2.png',
      imageAlt: 'self help federal credit union',
      imageWidth: '400',
      imageHeight: '113',
      linkUrl: 'https://www.self-helpfcu.org/',
    },
    {
      id: 2,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/csr/images/logo-ccfcu.png',
      imageAlt: 'cooperative center federal credit union',
      imageWidth: '474',
      imageHeight: '134',
      linkUrl: 'https://www.coopfcu.org/',
    },
    {
      id: 3,
      imageUrl:
        'https://www.nerdwallet.com/cdn/company/2021/csr/images/logo-ncfcu-v4.png',
      imageAlt: 'northeast community federal credit union',
      imageWidth: '102',
      imageHeight: '100',
      linkUrl: 'https://necfcu.weebly.com/',
    },
  ],
};
